export default {
  products: [],
  types: [],
  userProducts: [],
  selectedProduct: null,
  error: false,
  errorMessage: ''
}